var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9662 5.65954C23.5946 4.09318 22.8386 2.08199 22.8388 0H16.6374V24.8859C16.5906 26.2329 16.0224 27.5091 15.0526 28.4452C14.0828 29.3813 12.7873 29.904 11.4395 29.9032C8.58965 29.9032 6.22148 27.5752 6.22148 24.6852C6.22148 21.2333 9.55298 18.6444 12.9848 19.708V13.3661C6.06092 12.443 0 17.8215 0 24.6852C0 31.3683 5.53912 36.1247 11.4194 36.1247C17.7212 36.1247 22.8388 31.007 22.8388 24.6852V12.0616C25.3535 13.8676 28.3727 14.8365 31.4686 14.8312V8.62979C31.4686 8.62979 27.6956 8.81042 24.9662 5.65954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.662ef922942c5fcb195994eaf67b88fa.svg";
export { ForwardRef as ReactComponent };